module.exports = __webpack_public_path__ + "static/media/hinted-MaisonNeue-Book.9d961a6c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/maison/hinted-MaisonNeue-Book.eot
// module id = 96
// module chunks = 0